/**
 * redcat 平台用的公共事件总线
 * */

class RedcatEventBus {
  listeners = {}
  rcTableListenerArray = []
  formRuntimeListenerArray = []

  // 也可以使用单例模式来创建全局的一个事件总线
  static getRedcatEventBusInstance () {
    if (!RedcatEventBus.instance) {
      RedcatEventBus.instance = new RedcatEventBus()
    }
    return RedcatEventBus.instance
  }

  $on (event, callback) {
    if (!(callback instanceof Function)) {
      throw new Error('$on callback is not a function')
    }
    if (!(event in this.listeners) || this.listeners[event] === null) {
      this.listeners[event] = []
    }
    let index = this.listeners[event].map(n => n.toString()).indexOf(callback.toString())
    if (index === -1) {
      this.listeners[event].push(callback)
    } else {
      this.listeners[event][index] = callback
    }
  }

  $emit (event, args) {
    if (!(event in this.listeners)) {
      return
    }
    const promise = []
    for (let listenerStack of this.listeners[event]) {
      promise.push(listenerStack.call(this, args))
    }
    return Promise.all(promise)
  }

  $off (event, fn) {
    const vm = this
    // 没传参数时清空所有监听
    if (!arguments.length) {
      this.listeners = Object.create(null)
      return vm
    }

    // 如果传了一个数组，则递归清除
    if (Array.isArray(event)) {
      for (let i = 0, l = event.length; i < l; i++) {
        this.$off(event[i])
      }
      return vm
    }

    // 获取当前event里所有的回调函数
    const cbs = vm.listeners[event]
    // 如果不存在回调函数，则直接返回，因为没有可以移除监听的内容
    if (!cbs) {
      return vm
    }
    // 如果没有指定要移除的回调函数，则移除该事件下所有的回调函数
    if (!fn) {
      vm.listeners[event] = null
      return vm
    }
    // 指定了要移除的回调函数
    let cb
    let i = cbs.length
    while (i--) {
      cb = cbs[i]
      // 在事件对应的回调函数数组里面找出要移除的回调函数，并从数组里移除
      if (cb === fn) {
        cbs.splice(i, 1)
        break
      }
    }
    return vm
  }
}

export default RedcatEventBus



// WEBPACK FOOTER //
// ./src/plugins/redcatEventBus/index.js